import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import ProtectedLayout from "../components/Layouts/ProtectedLayout";
import Notification from "@pages/Notification/Notification";
import InactivityLogout from "@components/Layouts/InactivityLogout";
import { useSocket } from "@utils/socket/socketContext";
import { toast } from "react-toastify";

type ProtectedRoutesProps = object;

const ProtectedRoutes: React.FC<ProtectedRoutesProps> = () => {
  const location = useLocation();
  const isUserLogedIn = true;

  if (!isUserLogedIn) {
    return (
      <Navigate to="/auth/login" state={{ from: location }} replace={true} />
    );
  }
  const { socket } = useSocket();

  useEffect(() => {
    if (socket) {
      // Notification listener
      socket.on("receive notification", (message) => {
        toast.success(typeof message === "string" ? message : JSON.stringify(message), {
          position: "top-center",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          style: {
            width: "360px",
            color: "#1a1a1a",
            fontWeight: 540,
            border: "1px solid #d0d7de",
            borderRadius: "8px",
            padding: "12px 16px",
            fontSize: "16px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
          },
        });
      });

      // Application listener receive status notification
      socket.on("receive application", (applicationData) => {
        const { notificationMessage } = applicationData;
        toast.info(notificationMessage || "You received a new loan application!", {
          position: "top-center",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          style: {
            width: "360px",
            color: "#1a1a1a",
            fontWeight: 540,
            border: "1px solid #d0d7de",
            borderRadius: "8px",
            padding: "12px 16px",
            fontSize: "16px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
          },
        });
      });
      socket.on("receive loan amount", (applicationData) => {
        const { notificationMessage } = applicationData;
        toast.info(notificationMessage || "You received a new loan application!", {
          position: "top-center",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          style: {
            width: "360px",
            color: "#1a1a1a",
            fontWeight: 540,
            border: "1px solid #d0d7de",
            borderRadius: "8px",
            padding: "12px 16px",
            fontSize: "16px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
          },
        });
      });

      socket.on("receive application status", (data) => {
        const { status, offerTitle, lenderName, notificationMessage } = data;

        toast.info(notificationMessage || `Status updated for ${offerTitle} by ${lenderName}`, {
          position: "top-center",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          style: {
            width: "360px",
            color: "#1a1a1a",
            fontWeight: 540,
            border: "1px solid #d0d7de",
            borderRadius: "8px",
            padding: "12px 16px",
            fontSize: "16px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
          },
        });
      });
      socket.on("receive offer completed", (data) => {
        const { offerTitle, notificationMessage } = data;

        toast.info(notificationMessage || `Your offer "${offerTitle}" has been completed.`, {
          position: "top-center",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          style: {
            width: "360px",
            color: "#1a1a1a",
            fontWeight: 540,
            border: "1px solid #d0d7de",
            borderRadius: "8px",
            padding: "12px 16px",
            fontSize: "16px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
          },
        });
      });
      socket.on("receive contract generated", (data) => {
        const { offerTitle, notificationMessage } = data;

        toast.info(notificationMessage || `A contract has been generated for your offer "${offerTitle}".`, {
          position: "top-center",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          style: {
            width: "360px",
            color: "#1a1a1a",
            fontWeight: 540,
            border: "1px solid #d0d7de",
            borderRadius: "8px",
            padding: "12px 16px",
            fontSize: "16px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
          },
        });
      });
      socket.on("receive contract signed", (data) => {
        const { offerTitle, notificationMessage } = data;

        toast.info(notificationMessage || `Borrower signed and returned contract for "${offerTitle}".`, {
          position: "top-center",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          style: {
            width: "360px",
            color: "#1a1a1a",
            fontWeight: 540,
            border: "1px solid #d0d7de",
            borderRadius: "8px",
            padding: "12px 16px",
            fontSize: "16px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
          },
        });
      });


    }
    return () => {
      if (socket) {
        socket.off("receive notification");
        socket.off("receive application");
        socket.off("receive application status");
        socket.off("receive offer completed");
        socket.off("receive contract generated");
        socket.off("receive contract signed");
        socket.off("receive loan amount");
      }
    };
  }, [socket]);

  return (
    <ProtectedLayout>
      <InactivityLogout>
        <Outlet />
        <Notification />
      </InactivityLogout>
    </ProtectedLayout>
  );
};
export default ProtectedRoutes;
